import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './styles/services.css';
import { FaCode } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { motion, useInView } from 'framer-motion';
import './styles/bookingwidget.css'

const ServicesCards = () => {
    const services = [
        {
          title: 'Web Development🌐',
          description: 'We create scalable, modern web applications tailored to your business needs, optimized for performance, security, and seamless user experience.',
          details: [
            'Custom web application development',
            'Responsive and mobile-optimized solutions',
            'Reliable, secure coding standards',
            'Scalable architecture for future growth'
          ],
          slug: 'web-development'
        },
        {
          title: 'Web Design',
          description: 'We craft bespoke, user-friendly designs to showcase your brand personality, delivering engaging digital experiences optimized for usability.',
          details: [
            'Bespoke design tailored to your brand identity',
            'Intuitive user experience (UX) and interface design (UI)',
            'Responsive designs optimized for all devices',
            'Modern and visually engaging aesthetics'
          ],
          slug: 'web-design'
        },
        {
          title: 'Content Writing📝',
          description: 'We produce engaging, authentic content that clearly communicates your story, resonates with your audience, and drives conversions.',
          details: [
            'Website copy optimized for clarity and conversions',
            'Professional blog posts and articles to boost engagement',
            'Brand storytelling to connect emotionally with your audience',
            'SEO-driven content strategy to increase visibility'
          ],
          slug: 'content-writing'
        },
        {
          title: 'SEO Optimising',
          description: 'Our strategic SEO services boost your search engine rankings, increase web traffic, and maximize your brand’s visibility everywhere.',
          details: [
            'Strategic approach to continually improve rankings and visibility',
            'Reliable keyword research and SEO planning',
            'SEO-focused content optimization',
            'Regular analytics and performance reporting'
          ],
          slug: 'seo-optimising'
        }
      ];
      

  return (
    <div className='services'>
        <Container className="my-5">
          <h2 className='services-title'>How we can help.💡</h2>
          <p className='sub-title'>At InterWebb, we believe that your website is more than just an online presence—it’s the digital heartbeat of your business. We specialize in crafting custom, responsive web solutions that not only capture the essence of your brand but also engage and convert your target audience. Whether you need a sleek new design, robust e-commerce integration, or optimization for better search engine performance, our team of experts is here to transform your vision into a dynamic, high-performing website.</p>
        <Row>
        {services.map((service, index) => (
            <Col key={index} xs={12} md={6} lg={3} className="mb-4">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 2 }}
              className="h-100"
            >
                <Card className="h-100">
                    <Card.Body className="d-flex flex-column">
                    <Card.Title className="service-title">
                    <h2>
                    {service.title === 'Web Design' ? (
                        <>
                            Web<br />Design🎨
                        </>
                    ) : service.title === 'SEO Optimising' ? (
                        <>
                            SEO<br />Optimising🚀
                        </>
                    ) : (
                        service.title
                    )}
                  </h2>
                    </Card.Title>
                    <Card.Text>
                        <p>{service.description}</p>
                        <ul className='service-details'>
                        {service.details.map((detail, idx) => (
                            <li key={idx}>
                                {detail}
                            </li>
                        ))}
                        </ul>
                    </Card.Text>
                    <Link to={`/services/${service.slug}`} className='primary-btn mt-auto'>
                      More Info
                    </Link>
                    </Card.Body>
                </Card>
              </motion.div>
            </Col>
        ))}
        </Row>
    </Container>
    </div>
    

  );
};

export default ServicesCards;
